import React from "react";

import Sale from "../details/Sale";
import { DetailModal } from "../ui";

const SaleModal = (props) => {
    const { open, selectedSale, setSelectedSale, handleClose, openSaleModal } = props;

    if (!selectedSale) return null;

    return (
        <DetailModal
            open={open}
            onClose={handleClose}
            size="xl"
            title="Sale Details"
            fullPagePath={`/sales/${selectedSale._id}`}
        >
            <Sale
                selectedSale={selectedSale}
                setSelectedSale={setSelectedSale}
                openSaleModal={openSaleModal}
            />
        </DetailModal>
    );
};

export default SaleModal;
